import { Injectable } from '@angular/core';
import { FinanceService } from './finance.service';
import { permissionMap } from '../configurations/finance/constants/constants';

@Injectable({
  providedIn: 'root'
})
export class FinanceModulePermissionService {
  userPermissions: any[] = [];
  chartMenuPermission: boolean = false;
  ledgerMenuPermission: boolean = false;
  journalMenuPermission: boolean = false;
  glMenuPermission: boolean = false;
  trialMenuPermission: boolean = false;
  bankMenuPermission: boolean = false;
  statementMenuPermission: boolean = false;
  plMenuPermission: boolean = false;
  balanceMenuPermission: boolean = false;
  cashflowMenuPermission: boolean = false;
  bankReconcileMenuPermission: boolean = false;
  expenseMenuPermission: boolean = false;
  creditcardMenuPermission: boolean = false;
  ccReconcileMenuPermission: boolean = false;
  accountingPeriodsMenuPermission: boolean = false;
  closingYearsMenuPermission: boolean = false;
  constructor(private financeService: FinanceService,) { }

  getPermission() {
    this.userPermissions = this.financeService.getPermissionData();
    permissionMap.forEach(item => {
      this[item.permissionVar] = this.checkPermission(item.objectName);
    });
  }

  checkPermission(objectName: string): boolean {
    return this.userPermissions?.some(p => p.objectName === objectName && p.permissions.some(permission => permission.statusId === 1)) ?? false;
  }

  getAllPermissions() {
    return {
      chartMenuPermission: this.chartMenuPermission,
      ledgerMenuPermission: this.ledgerMenuPermission,
      journalMenuPermission: this.journalMenuPermission,
      glMenuPermission: this.glMenuPermission,
      trialMenuPermission: this.trialMenuPermission,
      bankMenuPermission: this.bankMenuPermission,
      statementMenuPermission: this.statementMenuPermission,
      plMenuPermission: this.plMenuPermission,
      balanceMenuPermission: this.balanceMenuPermission,
      cashflowMenuPermission: this.cashflowMenuPermission,
      bankReconcileMenuPermission: this.bankReconcileMenuPermission,
      expenseMenuPermission: this.expenseMenuPermission,
      creditcardMenuPermission: this.creditcardMenuPermission,
      ccReconcileMenuPermission: this.ccReconcileMenuPermission,
      accountingPeriodsMenuPermission: this.accountingPeriodsMenuPermission,
      closingYearsMenuPermission: this.closingYearsMenuPermission,
    };
  }
}
